import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import swal from "sweetalert2";
import ItemTransformConfig from './ItemTransformConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus} from '@fortawesome/free-solid-svg-icons';

const ItemTransformForm = (props) =>{
    const t = useTranslate();

    const [showConfig,setShowConfig]=useState((props.setLoading) ? false : true)
    const [validButton,setValidButton]=useState(false)
    const [reload,setReload]=useState(Date.now()) 

    // Datas d'article transform
    const [datasTransform,setDatasTransform]=useState([])
    const [datasForm,setDatasForm]=useState([])

    // Recupère les infos d'article transform à chaque sélection d'article id (itemId)
    useEffect(function () {
        ( async function(){
            if (props.itemId) {
                if (props.setLoading) props.setLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article_transform/one/"+props.itemId
                ).then((response) => {
                    if(response.data.hasOwnProperty('valid') && !response.data.valid){
                        swal.fire(t('articleNoReferenceFind'), "", "error");
                    }else{   
                        setDatasTransform(response.data.data)
                        if (props.setLoading) setShowConfig(true) 
                        if (props.reload) setValidButton(false)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    let messageError
                    if(error.response==undefined){
                        messageError='unknowError'
                    }
                    else if(error.response.status==403){
                        messageError='forbiddenGeneral'
                    }
                    else {
                        messageError='unknowError'
                    }
                    swal.fire(t(messageError), "", "error");
                })
                if (props.setLoading) props.setLoading(false)
            }
        else {
            if (props.setLoading) setShowConfig(false)
        }
        })()
    }, [props.itemId,reload])

    // Mise à jour de datasForm pour affichage du formulaire
    useEffect(function () {
        if (datasTransform != null && datasTransform.article_transform != null) {
            let datasTemp=[]

            Object.values(datasTransform.article_transform).forEach((value) => {
                datasTemp.push({id:value.article_component.id,quantity:value.quantity,name:value.article_component.name,_key:Date.now()+Math.random()})
            });
            setDatasForm(datasTemp)
        }
        else setDatasForm([])

    }, [datasTransform])

    // Ajouter une ligne
    const addLine = () => {
        setDatasForm(prev => [...prev,{_key:Date.now()+Math.random(),quantity:1}])
    }

    // Supprimer une ligne
    const handleRemoveLine = (index) => {
        setDatasForm(prev => 
            prev.filter(line => line._key !== index)
        )
    }

    // Validation de la modale
    const handleSubmit = async () => {
        let datasTemp = {components:{}}

        datasForm.forEach((value,index) =>{
            if (value.id!=undefined && value.quantity!=undefined) {
                datasTemp.components[value.id] = value.quantity
            }
        });

        setValidButton(true)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/article_transform/"+props.itemId,datasTemp
        ).then((response) => {
            if(response.data.hasOwnProperty('valid') && !response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
                setValidButton(false)
            }else{
                if (props.closeModal) {   
                    props.closeModal()
                }
                if (props.setReload) {
                    props.setReload(Date.now())
                }
                if (props.reload) {
                    setReload(Date.now())
                }
            } 
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })   
        if (!props.reload) setValidButton(false)
    };

    return (
        <>
            {showConfig &&
            <>
                <div className='row'>
                    <div>
                        <label>
                            {t('newLine')}:&nbsp;&nbsp;
                        </label>
                        <button
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={()=>addLine()}
                        >
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                    </div>
                </div>
                <div className='row'>
                    <span className="col-6 form-group" style={{marginBottom:'0'}}>
                        <label>{t('article')}</label>
                    </span>
                    <span className="col-6 form-group" style={{marginBottom:'0'}}>
                        <label>{t('quantity')}</label>
                    </span>
                </div>
                {
                    (datasForm.length>0) && datasForm.map((value, index)=>{
                        return (value.id) ?
                            <ItemTransformConfig key={value._key}
                                itemId={props.itemId}
                                index={value._key}
                                articleId={value.id}
                                articleName={value.name}
                                quantity={value.quantity}
                                handleRemoveLine={() => handleRemoveLine(value._key)}
                                setDatasForm={setDatasForm}
                            ></ItemTransformConfig>
                        :
                            <ItemTransformConfig key={value._key} 
                                itemId={props.itemId}
                                index={value._key}
                                handleRemoveLine={() => handleRemoveLine(value._key)}
                                setDatasForm={setDatasForm}
                            ></ItemTransformConfig>
                    })
                }
                <button 
                    disabled={validButton} 
                    className='btn btn-primary' 
                    onClick={()=>handleSubmit()}
                >
                    {validButton ? <div className="spinner-border spinner-border-sm"></div> : t('btnValidate')}
                </button>
            </>
            }
        </>
    )
};

export default ItemTransformForm;